<template>
	<div id="otoshi" :class="{
		'user-can-interact-hammer': userCanInteractHammer,
		'is-down': isDown
		}">
		<div id="container" ref="container">
		</div>
	</div>
</template>

<script>
import _ from 'lodash'
import * as THREE from 'three';
import Stats from 'three/examples/jsm/libs/stats.module.js';
import gsap from "gsap";
// import * as Mod from "three.modifiers/dist/modifiers.min.js";
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
// import { GUI } from 'three/examples/jsm/libs/dat.gui.module.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
// import { BufferGeometryUtils } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { SubdivisionModifier } from 'three/examples/jsm/modifiers/SubdivisionModifier.js';
// import { ConvexObjectBreaker } from 'three/examples/jsm/misc/ConvexObjectBreaker.js';
// import { ConvexBufferGeometry } from 'three/examples/jsm/geometries/ConvexGeometry.js';
// let Ammo = window.Ammo
// import Ammo from "ammo.js";
// import * as Ammo from "ammo.js/ammo.js";
// import * as Ammo from "ammo.js/ammo.js";
// import * as Ammo from "ammo.js/builds/ammo.wasm.js";

// import router from '../router'
import { EXRLoader } from 'three/examples/jsm/loaders/EXRLoader.js';
// const urlParams = new URLSearchParams(window.location.search);
// const exrSource = '/textures/matcaps/PushingPoints_Matcaps/Warmsteel.png'
// const normalMapSource = '/textures/matcaps/9926-normal.jpg'
const normalMapSource = '/textures/wood-normal.jpg'

const faceMapSource = '/textures/head-3.jpg'
const faceRedMapSource = '/textures/head-red.jpg'

const isDebug = true && window.location.hostname.indexOf('localhost')>-1
const isMobile = window.innerWidth < 1024 || ("ontouchstart" in window || window.TouchEvent)

export default {
	name: 'Ammo',
	mounted () {
		// alert('click to select and move blob. hit ESC key to deselect.')
		this.initScene ()
	},
	data () {
		return {
			pressure: 0,
			pressureDisplay: 0,
			isPumping: false,
			userCanInteractHammer: false,
			isDown: false,
			gameLogicState: {
				rotx:0,
				roty:0,
				rotz:0,
				posx:0,
				posy:0,
				posz:0
			}
		}
	},
	methods: {
		getGameState () {
			if (this.getGameLogicState) {
				return this.getGameLogicState()
			}
		},
		enableUserInteraction () {
			this.userCanInteractHammer = true
		},
		disableUserInteraction () {
			this.userCanInteractHammer = false
		},
		resetObjects () {
			if (this.forceResetPositions) {
				this.forceResetPositions()
			}
		},
		changeLightMode (mode) {
			if (this.updateLightMode) {
				this.updateLightMode(mode)
			}
		},
		initScene () {

			let Ammo = this.$Ammo
			let self = this

			var wrapperElement = document.getElementById('otoshi')
			var ww=wrapperElement.clientWidth
			var wh=wrapperElement.clientHeight

			let container = this.$refs.container

			let clock;

			//variable declaration section
      let physicsWorld, scene, camera, renderer, rigidBodies = [], tmpTrans = null
      let ballObject = null, moveDirection = { left: 0, right: 0, forward: 0, back: 0 }
      let kinematicHammer = null,
			kMoveDirection = { left: 0, right: 0, forward: 0, back: 0, up: 0, down: 0 },
			tmpPos = new THREE.Vector3(),
			tmpQuat = new THREE.Quaternion();

      let ammoTmpPos = null, ammoTmpQuat = null;
      let mouseCoords = new THREE.Vector2(), raycaster = new THREE.Raycaster(), raytarget;
			let isDown = false

			let normalmap, matcap;

			// const raycaster = new THREE.Raycaster();
			const lastMouse = new THREE.Vector2();
			const mouse = new THREE.Vector2();
			const hammerPos = new THREE.Vector3();

      const STATE = { DISABLE_DEACTIVATION : 4 }
      const FLAGS = {
				CF_KINEMATIC_OBJECT: 2,
				CF_DYNAMIC_OBJECT: 1,
				CF_STATIC_OBJECT: 0 }

			let hammerGroup = new THREE.Group()


			let light1, light2, light3, light4;

			let facemap, faceredmap;
			// const spotLight1 = createSpotlight( 0xFF7F00 );
			// const spotLight2 = createSpotlight( 0x00FF7F );
			// const spotLight3 = createSpotlight( 0x7F00FF );

			let colors = []

			let positions = [
				{y:0*2.75+3},
				{y:1*2.75+3},
				{y:2*2.75+3},
				{y:3*2.75+3},
				{y:4*2.75+3},
				{y:5*2.75+3+3},
			]

			let forceObjectPositions = false
			let forceObjectPositionsCount = 0

			let gameLogicState = {
				rotx:0,
				roty:0,
				rotz:0,
				posx:0,
				posy:0,
				posz:0
			}

			let orbitControls;

			let stats;
      //Ammojs Initialization
      // Ammo().then(start)

			Ammo().then( function ( AmmoLib ) {

				Ammo = AmmoLib;

				start();

			} );

      function start (){

          tmpTrans = new Ammo.btTransform();
          ammoTmpPos = new Ammo.btVector3();
          ammoTmpQuat = new Ammo.btQuaternion();

          setupPhysicsWorld();
          setupVisual();
					setupInteraction()
					setupMaterials()

          createBlock();
          // createBall();
					createStack()
          createKinematicBox();

          setupEventHandlers();
          renderFrame();

      }

      function setupPhysicsWorld(){

          let collisionConfiguration  = new Ammo.btDefaultCollisionConfiguration(),
              dispatcher              = new Ammo.btCollisionDispatcher(collisionConfiguration),
              overlappingPairCache    = new Ammo.btDbvtBroadphase(),
              solver                  = new Ammo.btSequentialImpulseConstraintSolver();

          physicsWorld           = new Ammo.btDiscreteDynamicsWorld(dispatcher, overlappingPairCache, solver, collisionConfiguration);
          physicsWorld.setGravity(new Ammo.btVector3(0, -9.8*1.5, 0));

      }


      function setupVisual(){

          //create clock for timing
          clock = new THREE.Clock();

          //create the scene
          scene = new THREE.Scene();
          // scene.background = new THREE.Color( 0x111111 );
					// scene.background = new THREE.Color( 0x333333 );

          //create camera
          camera = new THREE.PerspectiveCamera( 40, window.innerWidth / window.innerHeight, 0.2, 100 );
          camera.position.set( 0, 10, 30 );
          camera.lookAt(new THREE.Vector3(0, 8, 0));

          //Add hemisphere light
          let hemiLight = new THREE.HemisphereLight( 0xffffff, 0xffffff, 0.3 );
          hemiLight.color.setHSL( 0.6, 0.6, 0.6 );
          hemiLight.groundColor.setHSL( 0.1, 1, 0.4 );
          hemiLight.position.set( 0, 50, 0 );
          scene.add( hemiLight );

          //Add directional light
          let dirLight = new THREE.DirectionalLight( 0xffffff , 0.5);
          dirLight.color.setHSL( 0.1, 1, 0.95 );
          dirLight.position.set( 1, 1.75, 1 );
          dirLight.position.multiplyScalar( 100 );
          scene.add( dirLight );

          dirLight.castShadow = true;
          dirLight.shadow.mapSize.width = 2048;
          dirLight.shadow.mapSize.height = 2048;

					//lights
					const sphere = new THREE.SphereBufferGeometry( 0.5, 16, 8 );

					light1 = new THREE.PointLight( 0xeeeeee, 2, 50 );
					// light1.add( new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( { color: 0xff0040 } ) ) );
					light1.castShadow = true;
					scene.add( light1 );

					light2 = new THREE.PointLight( 0xeeeeee, 2, 50 );
					// light2.add( new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( { color: 0x0040ff } ) ) );
					light2.castShadow = true;
					scene.add( light2 );

					if (!isMobile) {

						light3 = new THREE.PointLight( 0xeeeeee, 2, 50 );
						// light3.add( new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( { color: 0x80ff80 } ) ) );
						light3.castShadow = true;
						scene.add( light3 );

						light4 = new THREE.PointLight( 0xeeeeee, 2, 50 );
						// light4.add( new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( { color: 0xffaa00 } ) ) );
						light4.castShadow = true;
						scene.add( light4 );

					}

					function updateLightMode (mode=0) {
						if (mode==0) {
							hemiLight.color.setHSL( 0.6, 0.6, 0.6 );
							hemiLight.groundColor.setHSL( 0.1, 1, 0.4 );
							hemiLight.intensity = 0.3
							dirLight.intensity = 0.5
							if (light1) { light1.intensity = 2 }
							if (light2) { light2.intensity = 2 }
							if (light3) { light3.intensity = 2 }
							if (light4) { light4.intensity = 2 }
						} else {
							hemiLight.color.setHSL( 0.6, 0, 0.6 );
		          hemiLight.groundColor.setHSL( 0.1, 0, 0.4 );
							hemiLight.intensity = 1.5
							dirLight.intensity = 1
							if (light1) { light1.intensity = 0 }
							if (light2) { light2.intensity = 0 }
							if (light3) { light3.intensity = 0 }
							if (light4) { light4.intensity = 0 }
						}
					}

					self.updateLightMode = updateLightMode

					// spotLight1.position.set( 15, 40, 45 );
					// spotLight2.position.set( 0, 40, 35 );
					// spotLight3.position.set( - 15, 40, 45 );
					// scene.add( spotLight1, spotLight2, spotLight3 );

          let d = 50;

          dirLight.shadow.camera.left = -d;
          dirLight.shadow.camera.right = d;
          dirLight.shadow.camera.top = d;
          dirLight.shadow.camera.bottom = -d;

          dirLight.shadow.camera.far = 1000;

          //Setup the renderer
          renderer = new THREE.WebGLRenderer( { antialias: true, alpha: true } );
          // renderer.setClearColor( 0xbfd1e5 );
					let pixelRatio = isMobile ? 1 : window.devicePixelRatio
          renderer.setPixelRatio( window.devicePixelRatio );
          renderer.setSize( window.innerWidth, window.innerHeight );
          container.appendChild( renderer.domElement );

					renderer.shadowMap.enabled = true;
					renderer.shadowMap.type = THREE.PCFShadowMap;

					// tone mapping
					renderer.toneMapping = THREE.ACESFilmicToneMapping;
					// renderer.toneMapping = THREE.ReinhardToneMapping;
				 	renderer.toneMappingExposure = 1;

          // renderer.gammaInput = true;
          // renderer.gammaOutput = true;

          renderer.shadowMap.enabled = true;


					if (isDebug) {
						// orbitControls = new OrbitControls( camera, renderer.domElement );
						// orbitControls.target = new THREE.Vector3(0, 8, 0)
						// orbitControls.update();

						stats = new Stats();
						stats.domElement.style.position = 'absolute';
						stats.domElement.style.top = '0px';
						container.appendChild( stats.domElement );
					}

      }

			// function createSpotlight( color ) {
			//
			// 	const newObj = new THREE.SpotLight( color, 2 );
			//
			// 	newObj.castShadow = true;
			// 	newObj.angle = 0.3;
			// 	newObj.penumbra = 0.2;
			// 	newObj.decay = 2;
			// 	newObj.distance = 50;
			//
			// 	return newObj;
			//
			// }

			function raycast () {
				// update the picking ray with the camera and mouse position
				raycaster.setFromCamera( mouse, camera );

				// calculate objects intersecting the picking ray
				const intersects = raycaster.intersectObjects( [raytarget] );

				if (intersects.length>0) {
					hammerPos.copy(intersects[0].point)
					// console.log(intersects[0])
				}

				// for ( let i = 0; i < intersects.length; i ++ ) {
				//
				// 	intersects[ i ].object.material.color.set( 0xff0000 );
				//
				// }
			}

			function setupMaterials () {
				// manager
				const manager = new THREE.LoadingManager();

				// matcap
				// const loaderEXR = new EXRLoader( manager )
				// 	.setDataType( THREE.UnsignedByteType ); // default: FloatType

				// const matcap = loaderEXR.load( exrSource );
				// matcap = new THREE.TextureLoader().load( exrSource );

				// normalmap
				const loader = new THREE.TextureLoader( manager );

				manager.onStart = function ( url, itemsLoaded, itemsTotal ) {

					// console.log( 'Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );

				};

				manager.onLoad = function ( ) {

					// console.log( 'Loading complete!');

				};


				manager.onProgress = function ( url, itemsLoaded, itemsTotal ) {

					// console.log( 'Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );

				};

				manager.onError = function ( url ) {

					// console.log( 'There was an error loading ' + url );

				};

				normalmap = loader.load( normalMapSource );
				normalmap.wrapS = normalmap.wrapT = THREE.RepeatWrapping;
				normalmap.repeat.set( 2, 1 );

				facemap = loader.load( faceMapSource );
				facemap.wrapS = facemap.wrapT = THREE.RepeatWrapping;
				facemap.offset.set( -0.6 , 0.17 )
				facemap.repeat.set( 1, 0.6 );

				faceredmap = loader.load( faceRedMapSource );
				faceredmap.wrapS = faceredmap.wrapT = THREE.RepeatWrapping;
			}


			function setupInteraction () {

				mouse.x = 0.85

				const geometry = new THREE.PlaneBufferGeometry( 100, 100, 10, 10 );
				const material = new THREE.MeshBasicMaterial( {color: 0xffff00, side: THREE.DoubleSide, wireframe: true} );
				const plane = new THREE.Mesh( geometry, material );
				// plane.rotation.x = Math.PI/2
				// plane.

				plane.visible = false
				plane.position.y = 0
				scene.add( plane );
				raytarget = plane


				const geometry1 = new THREE.CylinderBufferGeometry( .7, .7, 4, 32, 4 );
				// const material1 = new THREE.MeshNormalMaterial( {color: 0xffff00} );
				const material1 = createMaterial('#ffeecc')

				let subdivisionModifier = new SubdivisionModifier( 0.5, true );
				let subdividedGeometry = geometry1.clone();
				let smoothGeometry = subdivisionModifier.modify(subdividedGeometry);

				const cylinder1 = new THREE.Mesh( smoothGeometry, material1 );
				cylinder1.rotation.z = Math.PI/2
				cylinder1.castShadow = true
				cylinder1.receiveShadow = true
				cylinder1.userData.defaultMaterial = material
				hammerGroup.add( cylinder1 )

				const geometry2 = new THREE.CylinderBufferGeometry( .15, .15, 10, 32 );
				// const material2 = new THREE.MeshNormalMaterial( {color: 0xffff00} );
				const material2 = createMaterial('#ffeecc')
				const cylinder2 = new THREE.Mesh( geometry2, material2 );
				cylinder2.rotation.z = Math.PI/2
				cylinder2.rotation.y = Math.PI/2
				cylinder2.position.z += 5
				cylinder2.castShadow = true
				cylinder2.receiveShadow = true
				cylinder2.userData.defaultMaterial = material2
				hammerGroup.add( cylinder2 )

				scene.add( hammerGroup );

			}

      function renderFrame(){

          let deltaTime = clock.getDelta();

					raycast()
          // moveBall();
					updateLights()

          moveKinematic();

					moveHammer();

          updatePhysics( deltaTime );

					if (gameLogic) {gameLogic()}

          renderer.render( scene, camera );

					if (isDebug) {
						if (stats) {
							stats.update();
						}
					}

          requestAnimationFrame( renderFrame );

      }

			function updateLights () {
				const time = Date.now() * 0.0005;

				if (light1) {
					light1.position.x = Math.sin( time * 0.7 ) * 30;
					light1.position.y = Math.cos( time * 0.5 ) * 40;
					light1.position.z = Math.cos( time * 0.3 ) * 30;
				}
				if (light2) {
					light2.position.x = Math.cos( time * 0.3 ) * 30;
					light2.position.y = Math.sin( time * 0.5 ) * 40;
					light2.position.z = Math.sin( time * 0.7 ) * 30;
				}
				if (light3) {
					light3.position.x = Math.sin( time * 0.7 ) * 30;
					light3.position.y = Math.cos( time * 0.3 ) * 40;
					light3.position.z = Math.sin( time * 0.5 ) * 30;
				}
				if (light4) {
					light4.position.x = Math.sin( time * 0.3 ) * 30;
					light4.position.y = Math.cos( time * 0.7 ) * 40;
					light4.position.z = Math.sin( time * 0.5 ) * 30;
				}

			}

			let gameLogic = _.throttle(function() {

				for ( let i = 0; i < rigidBodies.length; i++ ) {
						let objThree = rigidBodies[ i ];
						let id = objThree.userData.id
						let rotx = _.round(objThree.rotation.x, 2)
						let roty = _.round(objThree.rotation.y, 2)
						let rotz = _.round(objThree.rotation.z, 2) // check if flipped
						let posx = _.round(objThree.position.x, 2)
						let posy = _.round(objThree.position.y, 2) // check height to see where it's at
						let posz = _.round(objThree.position.z, 2)

						// console.log(i,posy)

						if (id=='stack-top') {
							gameLogicState = {
								rotx:rotx,
								roty:roty,
								rotz:rotz,
								posx:posx,
								posy:posy,
								posz:posz
							}
							// console.log(id, rotz, posy)
						}
						// let objAmmo = objThree.userData.physicsBody;
						// let ms = objAmmo.getMotionState();
						// if ( ms ) {
						// 	ms.getWorldTransform( tmpTrans );
						// 	let p = tmpTrans.getOrigin();
						// 	let q = tmpTrans.getRotation();
						// 	objThree.position.set( p.x(), p.y(), p.z() );
						// 	objThree.quaternion.set( q.x(), q.y(), q.z(), q.w() );
						// }
				}

			}, 500)

			function getGameLogicState() {
				return gameLogicState
			}
			self.getGameLogicState=getGameLogicState

      function setupEventHandlers(){

          // window.addEventListener( 'keydown', handleKeyDown, false);
					window.addEventListener( 'resize', onWindowResize, false );
          // window.addEventListener( 'keyup', handleKeyUp, false);
          container.addEventListener( 'mousedown', onMouseDown, false );
					container.addEventListener( 'mousemove', onMouseMove, false );
					container.addEventListener( 'mouseup', onMouseUp, false );

					container.addEventListener( 'touchstart', onMouseDown, false );
					container.addEventListener( 'touchmove', onMouseMove, false );
					container.addEventListener( 'touchend', onMouseUp, false );

      }


      // function handleKeyDown(event){
			//
      //     let keyCode = event.keyCode;
			//
      //     switch(keyCode){
			//
      //         case 87: //W: FORWARD
      //             moveDirection.forward = 1
      //             break;
			//
      //         case 83: //S: BACK
      //             moveDirection.back = 1
      //             break;
			//
      //         case 65: //A: LEFT
      //             moveDirection.left = 1
      //             break;
			//
      //         case 68: //D: RIGHT
      //             moveDirection.right = 1
      //             break;
			//
      //         case 38: //↑: FORWARD
      //             kMoveDirection.forward = 1
      //             break;
			//
      //         case 40: //↓: BACK
      //             kMoveDirection.back = 1
      //             break;
			//
      //         case 37: //←: LEFT
      //             kMoveDirection.left = 1
      //             break;
			//
      //         case 39: //→: RIGHT
      //             kMoveDirection.right = 1
      //             break;
			//
      //     }
      // }
			//
			//
      // function handleKeyUp(event){
      //     let keyCode = event.keyCode;
			//
      //     switch(keyCode){
      //         case 87: //FORWARD
      //             moveDirection.forward = 0
      //             break;
			//
      //         case 83: //BACK
      //             moveDirection.back = 0
      //             break;
			//
      //         case 65: //LEFT
      //             moveDirection.left = 0
      //             break;
			//
      //         case 68: //RIGHT
      //             moveDirection.right = 0
      //             break;
			//
      //         case 38: //↑: FORWARD
      //             kMoveDirection.forward = 0
      //             break;
			//
      //         case 40: //↓: BACK
      //             kMoveDirection.back = 0
      //             break;
			//
      //         case 37: //←: LEFT
      //             kMoveDirection.left = 0
      //             break;
			//
      //         case 39: //→: RIGHT
      //             kMoveDirection.right = 0
      //             break;
      //     }
			//
      // }

			function onMouseMove ( event ) {

				if (!self.userCanInteractHammer) {
					return
				}

				let e = event || window.event
				let ex = e.clientX || (e.touches && e.touches[0].pageX) || lastMouse.x
				let ey = e.clientY || (e.touches && e.touches[0].pageY) || lastMouse.y

				lastMouse.x = ex
				lastMouse.y = ey
				// let x = event.movementX
				// let y = event.movementY

				if (isDown) {

					mouse.x = ( ex / window.innerWidth ) * 2 - 1;
					mouse.y = - ( ey / window.innerHeight ) * 2 + 1;

					// console.log(x,y)
					//
					// kMoveDirection.down = Math.min(Math.max(y,-3), 3)
					// kMoveDirection.right = Math.min(Math.max(x,-3), 3)



					// if (y > 0) {
					// 	kMoveDirection.down = 1
					// 	kMoveDirection.up = 0
					// } else {
					// 	kMoveDirection.down = 0
					// 	kMoveDirection.up = 1
					// }
					//
					// if (x > 0) {
					// 	kMoveDirection.right = 1
					// 	kMoveDirection.left = 0
					// } else {
					// 	kMoveDirection.right = 0
					// 	kMoveDirection.left = 1
					// }

				}
			}

			function onWindowResize() {

				camera.aspect = window.innerWidth / window.innerHeight;
				camera.updateProjectionMatrix();

				renderer.setSize( window.innerWidth, window.innerHeight );

				// renderFrame();

			}

			function onMouseUp ( event ) {

				if (!self.userCanInteractHammer) {
					return
				}

				kMoveDirection.down = 0
				kMoveDirection.right = 0
				kMoveDirection.up = 0
				kMoveDirection.left = 0

				isDown = false
				self.isDown = false
			}


      function onMouseDown ( event ) {

				if (!self.userCanInteractHammer) {
					return
				}

					let e = event || window.event
					let ex = e.clientX || e.touches[0].pageX
					let ey = e.clientY || e.touches[0].pageY

					isDown = true
					self.isDown = true

          mouseCoords.set(
              ( ex / window.innerWidth ) * 2 - 1,
              - ( ey / window.innerHeight ) * 2 + 1
          );


          raycaster.setFromCamera( mouseCoords, camera );

          // // Creates a ball and throws it
					//
          // tmpPos.copy( raycaster.ray.direction );
          // tmpPos.add( raycaster.ray.origin );
					//
					//
          // let pos = {x: tmpPos.x, y: tmpPos.y, z: tmpPos.z};
          // let radius = 1;
          // let quat = {x: 0, y: 0, z: 0, w: 1};
          // let mass = 1;
					//
          // //threeJS Section
          // let ball = new THREE.Mesh(new THREE.SphereBufferGeometry(radius), new THREE.MeshPhongMaterial({color: 0x6b246e}));
					//
          // ball.position.set(pos.x, pos.y, pos.z);
					//
          // ball.castShadow = true;
          // ball.receiveShadow = true;
					//
          // scene.add(ball);
					//
					//
          // //Ammojs Section
          // let transform = new Ammo.btTransform();
          // transform.setIdentity();
          // transform.setOrigin( new Ammo.btVector3( pos.x, pos.y, pos.z ) );
          // transform.setRotation( new Ammo.btQuaternion( quat.x, quat.y, quat.z, quat.w ) );
          // let motionState = new Ammo.btDefaultMotionState( transform );
					//
          // let colShape = new Ammo.btSphereShape( radius );
          // colShape.setMargin( 0.05 );
					//
          // let localInertia = new Ammo.btVector3( 0, 0, 0 );
          // colShape.calculateLocalInertia( mass, localInertia );
					//
          // let rbInfo = new Ammo.btRigidBodyConstructionInfo( mass, motionState, colShape, localInertia );
          // let body = new Ammo.btRigidBody( rbInfo );
					//
          // physicsWorld.addRigidBody( body );
					//
          // tmpPos.copy( raycaster.ray.direction );
          // tmpPos.multiplyScalar( 100 );
					//
          // body.setLinearVelocity( new Ammo.btVector3( tmpPos.x, tmpPos.y, tmpPos.z ) );
					//
          // ball.userData.physicsBody = body;
          // rigidBodies.push(ball);

      }



			function createStack() {
				// for (let i = 0; i < 5; i++) {
				// 	// let d = 1
				// 	// let h = .8
				// 	// let l = 1
				// 	// let m = 10
				// 	// let x = 0
				// 	// let z = 0
				// 	// let y = i*1.1
				// 	// pos.set( x, y, z );
				// 	// quat.set( 0, 0, 0, 1 );
				// 	// let board = createParalellepiped( d, h, l, m, pos, quat, createMaterial() );
				// 	let board = createCylinder({x: 0, y: i*2.1+3, z: 0});
				// 	// board.castShadow = true;
				// 	// board.receiveShadow = true;
				// }
				createCylinder({x: 0, y: positions[0].y, z: 0}, {x: 2, y: 2, z: 2},createMaterial('#e9e6d9'),'stack-0');
				createCylinder({x: 0, y: positions[1].y, z: 0}, {x: 2, y: 2, z: 2},createMaterial('#aa2b09'),'stack-1');
				createCylinder({x: 0, y: positions[2].y, z: 0}, {x: 2, y: 2, z: 2},createMaterial('#ee97b2'),'stack-2');
				createCylinder({x: 0, y: positions[3].y, z: 0}, {x: 2, y: 2, z: 2},createMaterial('#9e6002'),'stack-3');
				createCylinder({x: 0, y: positions[4].y, z: 0}, {x: 2, y: 2, z: 2},createMaterial('#0d340d'),'stack-4');
				createCylinder({x: 0, y: positions[5].y, z: 0}, {x: 2, y: 4, z: 2},createMaterial('face'),'stack-top');

				function forceResetPositions () {
					forceObjectPositions = true
					mouse.x = 0.85
					mouse.y = 0

					gameLogicState = {
						rotx:0,
						roty:0,
						rotz:0,
						posx:0,
						posy:0,
						posz:0
					}
					// forceObjectPositionsCount = 10
					// setTimeout(()=>{
					// 	forceObjectPositions = false
					// }, 500)

				}
				self.forceResetPositions = forceResetPositions

			}


			function createRandomColor() {

				return Math.floor( Math.random() * ( 1 << 24 ) );

			}

			function createMaterial( color ) {

				if (color == 'face') {
					const mat = new THREE.MeshStandardMaterial( {
						// color: new THREE.Color( color ),
						metalness: 0,
						roughness: .4,
						map: faceredmap,
						normalMap: normalmap,
						normalScale: new THREE.Vector2(0.75,0.75)
					})
					const materials = [
			       mat.clone(),
			       mat.clone(),
			       mat.clone(),
			       mat.clone(),
			       mat.clone(),
			       mat.clone()
			    ];

					materials[0].map = facemap;
					return materials
				}

				color = color || createRandomColor();
				// return new THREE.MeshPhongMaterial( { color: color } );
				// const mat = new THREE.MeshMatcapMaterial( {
				// 	// color: new THREE.Color().setHex( legos[i].color ).convertSRGBToLinear(),
				// 	color: new THREE.Color( color ).convertSRGBToLinear(),
				// 	// color: new THREE.Color( color ),
				// 	matcap: matcap,
				// 	normalMap: normalmap,
				// 	normalScale: new THREE.Vector2(1,1)
				// })
				// return mat

				const mat = new THREE.MeshStandardMaterial( {
					// color: new THREE.Color().setHex( legos[i].color ).convertSRGBToLinear(),
					// color: new THREE.Color( color ).convertSRGBToLinear(),
					color: new THREE.Color( color ),
					metalness: 0,
					roughness: .4,
					// maap: matcap,
					normalMap: normalmap,
					normalScale: new THREE.Vector2(0.75,0.75)
				})
				// mat.normalMap.wrapS = mat.normalMap.wrapT = THREE.RepeatWrapping;
				// mat.normalMap.repeat.set( 1 / 3, 1 / 3 );


				// const mat = new THREE.MeshNormalMaterial( {
				// })
				return mat

			}

			function createCylinder(pos = {x: 0, y: 4, z: 0}, scale = {x: 2, y: 2, z: 2}, mat = createMaterial(), id) {

				// let pos = pos;
				let radius = 2;
				let quat = {x: 0, y: 0, z: 0, w: 1};
				let mass = 30;

				let geom = new THREE.CylinderBufferGeometry( 1, 1, 1, 12, 4 )
				let subdivisionModifier = new SubdivisionModifier( 0.2, true );
				let subdividedGeometry = geom.clone();
				let smoothGeometry = subdivisionModifier.modify(subdividedGeometry);
				//threeJS Section
				let ball = ballObject = new THREE.Mesh(smoothGeometry, mat);

				ball.position.set(pos.x, pos.y, pos.z);
				ball.scale.set(scale.x, scale.y, scale.z);
				ball.castShadow = true;
				ball.receiveShadow = true;

				ball.userData.id = id
				ball.userData.defaultMaterial = mat

				scene.add(ball);


				//Ammojs Section
				let transform = new Ammo.btTransform();
				transform.setIdentity();
				transform.setOrigin( new Ammo.btVector3( pos.x, pos.y, pos.z ) );
				transform.setRotation( new Ammo.btQuaternion( quat.x, quat.y, quat.z, quat.w ) );
				let motionState = new Ammo.btDefaultMotionState( transform );

				const colShape = new Ammo.btCylinderShape( new Ammo.btVector3( 1 *scale.x, 0.5 * scale.y, 1*scale.z ) );
				// shape.setMargin( margin );
				// let colShape = new Ammo.btSphereShape( radius );
				colShape.setMargin( 0.05 );

				let localInertia = new Ammo.btVector3( 0, 0, 0 );
				colShape.calculateLocalInertia( mass, localInertia );

				let rbInfo = new Ammo.btRigidBodyConstructionInfo( mass, motionState, colShape, localInertia );
				let body = new Ammo.btRigidBody( rbInfo );

				body.setFriction(0.5);
				body.setRollingFriction(0.1);

				body.setActivationState( STATE.DISABLE_DEACTIVATION )


				physicsWorld.addRigidBody( body );

				ball.userData.physicsBody = body;
				rigidBodies.push(ball);

			}

      function createBlock(){

          let pos = {x: 0, y: 0, z: 0};
          let scale = {x: 15, y: 2, z: 15};
          let quat = {x: 0, y: 0, z: 0, w: 1};
          let mass = 0;

          //threeJS Section
          // let blockPlane = new THREE.Mesh(new THREE.BoxBufferGeometry(), new THREE.MeshPhongMaterial({color: 0x060300}));
					let boxgeom = new THREE.BoxBufferGeometry(1,1,1,8,8,8)
					let subdivisionModifier = new SubdivisionModifier( 0.1, true );
					let subdividedGeometry = boxgeom.clone();
					let smoothGeometry = subdivisionModifier.modify(subdividedGeometry);

					let blockPlane = new THREE.Mesh(smoothGeometry, createMaterial('#201916'));

          blockPlane.position.set(pos.x, pos.y, pos.z);
          blockPlane.scale.set(scale.x, scale.y, scale.z);

          blockPlane.castShadow = true;
          blockPlane.receiveShadow = true;

          scene.add(blockPlane);


          //Ammojs Section
          let transform = new Ammo.btTransform();
          transform.setIdentity();
          transform.setOrigin( new Ammo.btVector3( pos.x, pos.y, pos.z ) );
          transform.setRotation( new Ammo.btQuaternion( quat.x, quat.y, quat.z, quat.w ) );
          let motionState = new Ammo.btDefaultMotionState( transform );

          let colShape = new Ammo.btBoxShape( new Ammo.btVector3( scale.x * 0.5, scale.y * 0.5, scale.z * 0.5 ) );
          colShape.setMargin( 0.05 );

          let localInertia = new Ammo.btVector3( 0, 0, 0 );
          colShape.calculateLocalInertia( mass, localInertia );

          let rbInfo = new Ammo.btRigidBodyConstructionInfo( mass, motionState, colShape, localInertia );
          let body = new Ammo.btRigidBody( rbInfo );

          body.setFriction(4);
          body.setRollingFriction(10);

          physicsWorld.addRigidBody( body );
      }


      // function createBall(){
			//
      //     let pos = {x: 0, y: 4, z: 0};
      //     let radius = 2;
      //     let quat = {x: 0, y: 0, z: 0, w: 1};
      //     let mass = 1;
			//
      //     //threeJS Section
      //     let ball = ballObject = new THREE.Mesh(new THREE.SphereBufferGeometry(radius), new THREE.MeshPhongMaterial({color: 0xff0505}));
			//
      //     ball.position.set(pos.x, pos.y, pos.z);
			//
      //     ball.castShadow = true;
      //     ball.receiveShadow = true;
			//
      //     scene.add(ball);
			//
			//
      //     //Ammojs Section
      //     let transform = new Ammo.btTransform();
      //     transform.setIdentity();
      //     transform.setOrigin( new Ammo.btVector3( pos.x, pos.y, pos.z ) );
      //     transform.setRotation( new Ammo.btQuaternion( quat.x, quat.y, quat.z, quat.w ) );
      //     let motionState = new Ammo.btDefaultMotionState( transform );
			//
      //     let colShape = new Ammo.btSphereShape( radius );
      //     colShape.setMargin( 0.05 );
			//
      //     let localInertia = new Ammo.btVector3( 0, 0, 0 );
      //     colShape.calculateLocalInertia( mass, localInertia );
			//
      //     let rbInfo = new Ammo.btRigidBodyConstructionInfo( mass, motionState, colShape, localInertia );
      //     let body = new Ammo.btRigidBody( rbInfo );
			//
      //     body.setFriction(4);
      //     body.setRollingFriction(10);
			//
      //     body.setActivationState( STATE.DISABLE_DEACTIVATION )
			//
			//
      //     physicsWorld.addRigidBody( body );
			//
      //     ball.userData.physicsBody = body;
      //     rigidBodies.push(ball);
      // }



      function createKinematicBox(){

          let pos = {x: 20, y: 2.5, z: 0};
          let scale = {x: 4, y: 1, z: 1};
          let quat = {x: 0, y: 0, z: 0, w: 1};
          let mass = 100;

          //threeJS Section
          kinematicHammer = new THREE.Mesh(new THREE.BoxBufferGeometry(), new THREE.MeshNormalMaterial({color: 0x30ab78}));
					kinematicHammer.visible=false

          kinematicHammer.position.set(pos.x, pos.y, pos.z);
          kinematicHammer.scale.set(scale.x, scale.y, scale.z);

          kinematicHammer.castShadow = true;
          kinematicHammer.receiveShadow = true;

          scene.add(kinematicHammer);


          //Ammojs Section
          let transform = new Ammo.btTransform();
          transform.setIdentity();
          transform.setOrigin( new Ammo.btVector3( pos.x, pos.y, pos.z ) );
          transform.setRotation( new Ammo.btQuaternion( quat.x, quat.y, quat.z, quat.w ) );
          let motionState = new Ammo.btDefaultMotionState( transform );

          let colShape = new Ammo.btBoxShape( new Ammo.btVector3( scale.x * 0.5, scale.y * 0.5, scale.z * 0.5 ) );
          colShape.setMargin( 0.05 );

          let localInertia = new Ammo.btVector3( 0, 0, 0 );
          colShape.calculateLocalInertia( mass, localInertia );

          let rbInfo = new Ammo.btRigidBodyConstructionInfo( mass, motionState, colShape, localInertia );
          let body = new Ammo.btRigidBody( rbInfo );

          body.setFriction(5);
          // body.setRollingFriction(10);

          body.setActivationState( STATE.DISABLE_DEACTIVATION );
          body.setCollisionFlags( FLAGS.CF_KINEMATIC_OBJECT );


          physicsWorld.addRigidBody( body );
          kinematicHammer.userData.physicsBody = body;

      }



      function moveBall(){

          let scalingFactor = 20;

          let moveX =  moveDirection.right - moveDirection.left;
          let moveZ =  moveDirection.back - moveDirection.forward;
          let moveY =  0;

          if( moveX == 0 && moveY == 0 && moveZ == 0) return;

          let resultantImpulse = new Ammo.btVector3( moveX, moveY, moveZ )
          resultantImpulse.op_mul(scalingFactor);

          let physicsBody = ballObject.userData.physicsBody;
          physicsBody.setLinearVelocity( resultantImpulse );

      }

			function moveHammer () {
				hammerGroup.position.copy(kinematicHammer.position)
			}


      function moveKinematic(){

          let scalingFactor = 0.3;

          let moveX =  kMoveDirection.right - kMoveDirection.left;
          let moveZ =  kMoveDirection.back - kMoveDirection.forward;
          let moveY =  kMoveDirection.up - kMoveDirection.down;


          let translateFactor = tmpPos.set(moveX, moveY, moveZ);

          translateFactor.multiplyScalar(scalingFactor);

          kinematicHammer.translateX(translateFactor.x);
          kinematicHammer.translateY(translateFactor.y);
          kinematicHammer.translateZ(translateFactor.z);

					kinematicHammer.getWorldPosition(tmpPos);
					kinematicHammer.getWorldQuaternion(tmpQuat);


					// kinematicHammer.position.x = mouse.x * 20
					// kinematicHammer.position.y = mouse.y * 20

					kinematicHammer.position.x = hammerPos.x
					kinematicHammer.position.y = hammerPos.y
					kinematicHammer.position.z = hammerPos.z

					kinematicHammer.position.y = Math.max(kinematicHammer.position.y, 1.6)

					// console.log(kinematicHammer.position)

          let physicsBody = kinematicHammer.userData.physicsBody;

          let ms = physicsBody.getMotionState();
          if ( ms ) {

							// console.log(tmpPos)
							// tmpPos.y = Math.max(tmpPos.y, 0)

              ammoTmpPos.setValue(tmpPos.x, tmpPos.y, tmpPos.z);
              ammoTmpQuat.setValue( tmpQuat.x, tmpQuat.y, tmpQuat.z, tmpQuat.w);


              tmpTrans.setIdentity();
              tmpTrans.setOrigin( ammoTmpPos );
              tmpTrans.setRotation( ammoTmpQuat );

              ms.setWorldTransform(tmpTrans);

          }

      }




      function updatePhysics( deltaTime ){

					let timeScale = 1
					if (self.userCanInteractHammer) {
						timeScale = 3
					}
          // Step world
          physicsWorld.stepSimulation( deltaTime * timeScale, 10 );

          // Update rigid bodies
          for ( let i = 0; i < rigidBodies.length; i++ ) {
              let objThree = rigidBodies[ i ];

							if (forceObjectPositions) {

								// console.log('forceObjectPositions', i)
								objThree.userData.physicsBody.setCollisionFlags( FLAGS.CF_KINEMATIC_OBJECT );

								objThree.getWorldPosition(tmpPos);
								objThree.getWorldQuaternion(tmpQuat);

								objThree.position.x = 0
								objThree.position.y = positions[i].y
								objThree.position.z = 0

								let objAmmo = objThree.userData.physicsBody;
								objAmmo.setCollisionFlags( FLAGS.CF_KINEMATIC_OBJECT );

	              let ms = objAmmo.getMotionState();
								if ( ms ) {

										// console.log(tmpPos)
										// tmpPos.y = Math.max(tmpPos.y, 0)
										// ammoTmpPos.setValue(tmpPos.x, tmpPos.y, tmpPos.z);
										// ammoTmpQuat.setValue( tmpQuat.x, tmpQuat.y, tmpQuat.z, tmpQuat.w);
										//
										// tmpTrans.setIdentity();
										// tmpTrans.setOrigin( ammoTmpPos );
										// tmpTrans.setRotation( ammoTmpQuat );
										// ms.setWorldTransform(tmpTrans);

										let pos = {
											x:0,
											y: positions[i].y,
											z:0
										}
										let quat = {x: 0, y: 0, z: 0, w: 1};

										// console.log(i,pos)

										// let transform = new Ammo.btTransform();
										// transform.setIdentity();
										// transform.setOrigin( new Ammo.btVector3( pos.x, pos.y, pos.z ) );
										// transform.setRotation( new Ammo.btQuaternion( quat.x, quat.y, quat.z, quat.w ) );
										ammoTmpPos.setValue(pos.x, pos.y, pos.z);
										ammoTmpQuat.setValue( quat.x, quat.y, quat.z, quat.w);
										tmpTrans.setIdentity();
										tmpTrans.setOrigin( ammoTmpPos );
										tmpTrans.setRotation( ammoTmpQuat );
										ms.setWorldTransform(tmpTrans);

								}
							} else {

	              let objAmmo = objThree.userData.physicsBody;
								objAmmo.setCollisionFlags( FLAGS.CF_STATIC_OBJECT );

	              let ms = objAmmo.getMotionState();
	              if ( ms ) {
										//
	                  ms.getWorldTransform( tmpTrans );
	                  let p = tmpTrans.getOrigin();
	                  let q = tmpTrans.getRotation();
	                  objThree.position.set( p.x(), p.y(), p.z() );
	                  objThree.quaternion.set( q.x(), q.y(), q.z(), q.w() );
										//
	              }

							}
          }

					if (forceObjectPositions) {
						physicsWorld.stepSimulation( deltaTime * timeScale, 10 );
						physicsWorld.stepSimulation( deltaTime * timeScale, 10 );
						physicsWorld.stepSimulation( deltaTime * timeScale, 10 );
						// physicsWorld.stepSimulation( deltaTime * timeScale, 10 );
						// physicsWorld.stepSimulation( deltaTime * timeScale, 10 );
						forceObjectPositions=false
					}
					// if (forceObjectPositionsCount>0) {
					// 	forceObjectPositionsCount--
					// } else {
					// 	forceObjectPositions=false
					// }

      }


		}
	}
}
</script>

<style lang="scss" scoped>
#otoshi {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
	z-index: 2;

	&.user-can-interact-hammer {
		cursor: grab;
		cursor: -moz-grab;
		cursor: -webkit-grab;
		&.is-down {
			cursor: grabbing;
	    cursor: -moz-grabbing;
	    cursor: -webkit-grabbing;
		}
	}
}
#container {
	position: absolute;
	top: 0;
	left: 0;
}
.log {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100px;
	height: 50px;
	z-index: 99;
}
.text {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	padding: .5em .5em .25em;
	font-size: 30px;
	text-align: left;
	line-height: 1;
	font-family: 'Nimbus Sans';
	text-transform: uppercase;
	color: #000;
}
.bar {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	background: #fe0;
	mix-blend-mode: multiply;
}
</style>
